<template>
  <div class="container-fluid" style="margin-top:20px;">
    <li class="manage-list-row clearfix">
      <div class="job-info">
        <div class="row">
          <div class="col-md-3 col-sm-3 job-img">
            <img :src="c.logo1" class="attachment-thumbnail" alt="">
          </div>
          <div class="col-md-9 col-sm-9">
            <h3 class="job-name" v-if="c.eName != null">{{ c.eName }}</h3>
            <h3 class="job-name" v-if="c.cName != null">{{ c.cName }}</h3>
            <small class="job-company">{{ c.desc }}</small>
          </div>
        </div>
      </div>
    </li>
    <li class="manage-list-row clearfix">
      <div class="row" style="padding:10px">
        <div class="col-md-6 col-sm-6" v-if="c.companyType">
          <label>{{ $t('crm.my-client.company-type') }}</label><br>
          <strong>{{ companyType[c.companyType] }}</strong>
        </div>
        <div class="col-md-6 col-sm-6" v-if="c.companySize">
          <label>{{ $t('crm.my-client.company-size') }}</label><br>
          <strong>{{ companyType[c.companySize] }}</strong>
        </div>
        <div class="col-md-6 col-sm-6" v-if="c.location">
          <label>{{ $t('crm.my-client.location') }}</label><br>
          <strong>{{ c.location }}</strong>
        </div>
        <div class="col-md-6 col-sm-6" v-if="c.industry">
          <label>{{ $t('crm.my-client.industry') }}</label><br>
          <strong>{{ c.industry }}</strong>
        </div>
        <div class="col-md-6 col-sm-6" v-if="c.website">
          <label>{{ $t('crm.my-client.website') }}</label><br>
          <strong><a :href="c.website" target="_blank">{{ c.website }}</a></strong>
        </div>
      </div>
    </li>
  </div>
</template>
<script>
// @ is an alias to /src
import moment from 'moment'

export default {
  name: 'CompanyInfo',
  props: ['c'],
  data: function() {
  return {
  }
  },
  computed: {
    status: function() {
    }
  },
  methods: {
    
  },
  created: function() {
  }
}
</script>
